export class Bundle {
  constructor(readonly errors: Error) {}
}
